import { defineFormFactory } from "./define-form-factory"

import {
  JointContactInformation,
  JointHomeAddress,
  JointIncomeInformation,
  JointPersonalInformation,
  PrimaryBankAccountInformation,
  PrimaryBankCardInformation,
  PrimaryContactInformation,
  PrimaryEmployerInformation,
  PrimaryHomeAddress,
  PrimaryIdentityInformation,
  PrimaryIncomeInformation,
  PrimaryPersonalInformation,
  PrimaryPreferenceInformation,
  PrimaryReferenceInformation,
  PrimarySpouseInformation,
  PurchaseInformation,
  PrimaryJointApplicantSelection,
} from "../sections"

export const StandardFormFactory = defineFormFactory("standard", {
  steps: ["personal", "address", "contact", "additional", "spouse"],
  primarySections: (context) => {
    const shouldCollectIdentity = context.shouldRender(
      PrimaryIdentityInformation
    )

    switch (context.id) {
      case "personal":
        return [PurchaseInformation, PrimaryPersonalInformation]
      case "address":
        return [PrimaryHomeAddress]
      case "contact":
        return shouldCollectIdentity
          ? [
              PrimaryContactInformation,
              PrimaryIdentityInformation,
              PrimaryReferenceInformation,
              PrimaryJointApplicantSelection,
            ]
          : [
              PrimaryContactInformation,
              PrimaryEmployerInformation,
              PrimaryIncomeInformation,
              PrimaryReferenceInformation,
              PrimaryJointApplicantSelection,
            ]
      case "additional": {
        const otherSections = [PrimaryPreferenceInformation]

        const sections = [
          PrimaryBankAccountInformation,
          PrimaryBankCardInformation,
          ...otherSections,
        ]

        return shouldCollectIdentity
          ? [PrimaryEmployerInformation, PrimaryIncomeInformation, ...sections]
          : sections
      }
      case "spouse":
        return [PrimarySpouseInformation]
      default:
        return []
    }
  },
  jointSections: (context) => {
    switch (context.id) {
      case "personal":
        return [JointPersonalInformation]
      case "address":
        return [JointHomeAddress]
      case "contact":
        return [JointContactInformation, JointIncomeInformation]
      default:
        return []
    }
  },
})
